import installationInstructions from './installationInstructions';

const pewBulbContent = {
  installationInstructions
}

export { pewBulbContent };
